import React, { useState } from 'react';
import { goToCheckout } from '../lib/checkout';
export function Pricing() {
  const [selected, setSelected] = useState<'fq' | 'mega'>('mega');
  const handleCheckout = () => {
    goToCheckout(selected === 'mega' ? 'megapack' : 'fq');
  };
  const options = [{
    id: 'mega' as const,
    icon: '🏆',
    title: 'MEGAPACK COMPLETO',
    features: '12 tomos + 180 ejercicios + 6 bonus + 2 EBOOKS ÉLITE!',
    originalPrice: '$99.980',
    price: '$27.990',
    featured: true,
    badges: ['MÁS ELEGIDO', 'AHORRÁS $10.000']
  }, {
    id: 'fq' as const,
    icon: '🔬',
    title: 'FÍSICO-QUÍMICA',
    features: '12 tomos + 180 ejercicios + 6 bonus',
    originalPrice: '$49.990',
    price: '$18.990',
    featured: false,
    badges: []
  }];
  // Order: Featured first (Megapack), then FQ — matching competitor's vertical stacked layout with featured prominent
  // But competitor shows: standard, featured (middle), standard. With only 2 options, place featured on top for max conversion.
  return <section id="precios" className="bg-white py-12 md:py-16 px-4" data-id="element-173">
      <div className="max-w-2xl mx-auto" data-id="element-174">
        <h2 className="text-3xl md:text-4xl font-bold text-carbon text-center mb-4" data-id="element-175">
          Elegí tu Ciencias 360:
        </h2>
        <p className="text-center text-gray-600 mb-10 text-base md:text-lg" data-id="element-176">
          Todas las opciones incluyen los 6 bonus estratégicos
        </p>

        <div className="space-y-4 mb-6" data-id="element-177">
          {options.map(opt => {
          const isSelected = selected === opt.id;
          return <button key={opt.id} onClick={() => setSelected(opt.id)} className={`w-full text-left rounded-2xl border-2 p-5 md:p-6 transition-all ${isSelected ? 'border-sci-orange bg-orange-50' : 'border-gray-200 bg-white hover:border-gray-300'}`} data-id="element-178">
                <div className="flex items-center gap-4" data-id="element-179">
                  {/* Radio */}
                  <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center ${isSelected ? 'border-sci-orange' : 'border-gray-300'}`} data-id="element-180">
                    {isSelected && <div className="w-3 h-3 rounded-full bg-sci-orange" data-id="element-181"></div>}
                  </div>

                  {/* Content */}
                  <div className="flex-1 min-w-0" data-id="element-182">
                    <div className="flex flex-wrap items-center gap-2 mb-1" data-id="element-183">
                      <span className="text-xl" data-id="element-184">{opt.icon}</span>
                      <h3 className="font-bold text-carbon text-base md:text-lg" data-id="element-185">
                        {opt.title}
                      </h3>
                      {opt.badges.map((badge, i) => <span key={i} className={`text-[10px] md:text-xs font-bold px-2 py-1 rounded-full whitespace-nowrap ${badge.includes('AHORRÁS') ? 'bg-orange-100 text-sci-orange' : 'bg-sci-orange text-white'}`} data-id="element-186">
                          {badge.includes('MÁS') && '⭐ '}
                          {badge}
                        </span>)}
                    </div>
                    <p className="text-gray-600 text-xs md:text-sm" data-id="element-187">
                      {opt.features}
                    </p>
                  </div>

                  {/* Price */}
                  <div className="text-right flex-shrink-0" data-id="element-188">
                    <div className="text-gray-400 line-through text-xs md:text-sm" data-id="element-189">
                      {opt.originalPrice}
                    </div>
                    <div className={`font-bold text-xl md:text-2xl ${isSelected ? 'text-sci-orange' : 'text-carbon'}`} data-id="element-190">
                      {opt.price}
                    </div>
                  </div>
                </div>
              </button>;
        })}
        </div>

        {/* Single big CTA */}
        <button onClick={handleCheckout} className="w-full bg-sci-orange hover:bg-orange-600 text-white font-bold text-base md:text-lg py-5 px-6 rounded-xl transition-colors shadow-lg" data-id="element-191">
          {selected === 'mega' ? 'SÍ, QUIERO EL MEGAPACK COMPLETO →' : 'SÍ, QUIERO FÍSICO-QUÍMICA →'}
        </button>

        <p className="text-center text-sm text-gray-500 italic mt-4" data-id="element-192">
          {selected === 'mega' ? 'La opción más elegida por docentes que enseñan en los dos niveles' : 'Para docentes de 2do y 3ro año de secundaria'}
        </p>

        {/* Trust row */}
        <div className="flex flex-wrap justify-center gap-4 md:gap-6 text-xs md:text-sm text-gray-600 mt-8 pt-6 border-t border-gray-200" data-id="element-193">
          <span data-id="element-194">🔒 Pago seguro</span>
          <span data-id="element-195">⚡ Acceso en 5 min</span>
          <span data-id="element-196">🛡️ Garantía 7 días</span>
          <span data-id="element-197">💳 Mercado Pago</span>
        </div>
      </div>
    </section>;
}